module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(_vm.logoUrl) ? _c('img', {
    staticClass: "leading logo",
    attrs: {
      "src": _vm.logoUrl,
      "alt": "brand logo"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "trailing"
  }, [_vm._t("trailing", null, {
    title: _vm.title
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h3', [_vm._v("\n            " + _vm._s(_vm.title) + " "), (_vm.version) ? _c('i', [_vm._v(" ( version " + _vm._s(_vm.version.version) + " ) ")]) : _vm._e()]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.subTitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-915c4dc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/plano-header.vue
// module id = 3317
// module chunks = 0